import React, { PropsWithChildren } from 'react'

import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import TextLink from 'LuxKit/TextLink'
import { BOOKING_CONFIRMATION_PAGE_ROUTE } from 'supportAssistant/constants/supportAssistant'

type Props = PropsWithChildren<{
  orderId: string
}>

export default function LesaPurchaseSummaryTitle(props: Props) {
  const { children, orderId } = props

  const bookingConfirmationPageUrl = `${BOOKING_CONFIRMATION_PAGE_ROUTE}/${orderId}`

  return (
    <BodyTextBlock lineClamp={2} weight="bold" variant="medium">
      <TextLink href={bookingConfirmationPageUrl} underline={false} target="_blank">
        {children}
      </TextLink>
    </BodyTextBlock>
  )
}
